import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.q = bracketIndenting({
	line: "/",
})
